import React from "react";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import moment from "moment-timezone";
import { Image, Card, Responsive } from "semantic-ui-react";
import {
  formatCurrency,
  formatterUSD,
} from "../../../../../../commons/functions/generalFunctions";
import "./styles.css";
import DescriptionTable from "./components/DescriptionTable";
import MovilDescriptionTable from "./components/MovilDescriptionTable";
moment.locale();

const ModalItemHistory = (props) => {
  const { item } = props;
  return (
    <>
      {item ? (
        <MDBContainer>
          <MDBModal
            isOpen={props.openModal}
            toggle={() => props.event()}
            size="lg"
          >
            <MDBModalHeader
              className="modal-container-header"
              toggle={() => props.event()}
            >
              <Image className="modal-image-header" src="./assets/logo.png" />
            </MDBModalHeader>
            <MDBModalBody>
              <div className="container mt-5 mb-5">
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div style={{ padding: 15 }}>
                      <Card.Group
                        className="modal-item-card-group"
                        itemsPerRow={
                          item.orderHistory.length % 2
                            ? item.orderHistory.length === 1
                              ? item.orderHistory.length
                              : 2
                            : item.orderHistory.length / 2
                        }
                      >
                        {item.orderHistory.map((product, key) => (
                          <Card
                            key={key}
                            raised
                            style={{
                              backgroundImage: `url(${product.image})`,
                              display: "flex",
                              backgroundSize: "cover",
                              objectFit: "cover",
                              backgroundPosition: "center",
                              height:
                                item.orderHistory.length === 1 ? 140 * 2 : 140,
                              width:
                                item.orderHistory.length === 1 ? 140 * 2 : 140,
                            }}
                          />
                        ))}
                      </Card.Group>
                    </div>

                    <div className="mb-2">
                      <p>
                        <span className="font-weight-bold">Destinatario: </span>
                        {item.shipping.name}
                      </p>
                    </div>
                    {item.letter && (
                      <div className="mt-0 mb-2">
                        <p>
                          <span className="font-weight-bold">
                            Dedicatoria:{" "}
                          </span>
                          {item.letter}
                        </p>
                      </div>
                    )}
                    {item.note && (
                      <div className="mt-0 mb-2">
                        <p>
                          <span className="font-weight-bold">
                            Nota de la orden:{" "}
                          </span>
                          {item.note}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 col-12 ">
                    <div className="mb-4 mt-2">
                      <p>
                        <span className="font-weight-bold">ID. Factura: </span>
                        {props.item.invoiceNumber}
                      </p>
                    </div>
                    <div className="mb-2">
                      <p>
                        <span className="font-weight-bold">
                          Cantidad de productos comprados:{" "}
                        </span>
                        {item.orderHistory.length}
                      </p>
                    </div>
                    <div className="mb-2">
                      <p>
                        <span className="font-weight-bold">
                          Costo de envío:{" "}
                        </span>
                        {
                          <span style={{ fontWeight: "bold" }}>
                            {item.currency === "USD"
                              ? formatterUSD.format(
                                  parseFloat(
                                    item.shipping_cost ? item.shipping_cost : 0
                                  )
                                )
                              : formatCurrency(
                                  parseFloat(
                                    item.shipping_cost ? item.shipping_cost : 0
                                  )
                                )}
                          </span>
                        }
                      </p>
                    </div>
                    <div className="mb-4">
                      <p>
                        <span className="font-weight-bold">Total pagado: </span>
                        {
                          <span className="history-item-price">
                            {item.currency === "USD"
                              ? formatterUSD.format(
                                  parseFloat(
                                    item.usdTotal ? item.usdTotal : item.total
                                  )
                                )
                              : formatCurrency(parseFloat(item.total))}
                          </span>
                        }
                      </p>
                    </div>

                    <div className="mb-4">
                      <p>
                        <span className="font-weight-bold">
                          Dirección de envio:{" "}
                        </span>
                        {`${
                          item.shipping.department && item.shipping.department
                        }, ${item.shipping.city && item.shipping.city}, ${
                          item.shipping.addressLine1 &&
                          item.shipping.addressLine1
                        }, ${
                          item.shipping.addressLine2 &&
                          item.shipping.addressLine2
                        }`}
                      </p>
                    </div>
                    <div className="mb-2">
                      <p>
                        <span className="font-weight-bold">
                          Fecha de compra:{" "}
                        </span>
                        {moment(item.date).format("LLL")}
                      </p>
                    </div>
                    <div className="mb-2">
                      <p>
                        <span className="font-weight-bold">
                          Fecha de entrega:{" "}
                        </span>
                        {moment(item.shipping.date).format("LL")}
                      </p>
                    </div>
                    <div className="mb-2">
                      <p>
                        <span className="font-weight-bold">
                          Horario de entrega:{" "}
                        </span>
                        {item.shipping.afternoon === "true"
                          ? "Por la tarde"
                          : "Por la mañana"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-3">
                  <p>
                    <span className="font-weight-bold">
                      Descripción de productos:{" "}
                    </span>
                  </p>
                  <Responsive minWidth={991}>
                    <DescriptionTable item={item} />
                  </Responsive>
                  <Responsive maxWidth={990}>
                    <MovilDescriptionTable item={item} />
                  </Responsive>
                </div>
              </div>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="dark" onClick={() => props.event()}>
                Cerrar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModal>
        </MDBContainer>
      ) : null}
    </>
  );
};

export default ModalItemHistory;
